import axios from 'axios'
import { isAuthenticated, getToken, logout } from './Auth';

const ApiHandlerBlob = (baseURL: string) => {
    const api = axios.create({
        baseURL: baseURL + "/api/",
        responseType: `blob`,
        headers: {
            Authorization: 'Bearer ' + getToken()
        }
    
    })
    api.interceptors.request.use(function (config) {
        if (isAuthenticated() === true) {
            const token = getToken();
            if (token && config !== undefined && config.headers !== undefined) {
                config.headers.Authorization = `Bearer ${token}`;
            }
            return config;
        } else {
            return new Promise(() => {
                logout();
            });
        }
    }, function (error) {
        return Promise.reject(error);
    });

    api.interceptors.response.use(function (response) {
        return response;
    }, function (error) {

        var buttonErrorPopup = document.getElementById("ErrorPopupButton");
        if (buttonErrorPopup) {
            var message = "";
            if (error.response) {
                if (error.response.data?.message) {
                    message += error.response.data.message;
                }
                if (error.response.data?.errors) {
                    var errors = Object.keys(error.response.data.errors) as []
                    for (let index = 0; index < errors.length; index++) {
                        message += " " + error.response.data.errors[errors[index]][0].toString();
                    }
                }
            }
            else {
                message = error;
            }

            buttonErrorPopup.innerText = message;
            buttonErrorPopup.click();
        }
        return Promise.reject(error);
    });

    return api;
};

export default ApiHandlerBlob;
